/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UserProfile interface.
 */
export function instanceOfUserProfile(_value) {
    return true;
}
export function UserProfileFromJSON(json) {
    return UserProfileFromJSONTyped(json, false);
}
export function UserProfileFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'email': json['email'] == null ? undefined : json['email'],
        'name': json['name'] == null ? undefined : json['name'],
        'photoURL': json['photoURL'] == null ? undefined : json['photoURL'],
    };
}
export function UserProfileToJSON(json) {
    return UserProfileToJSONTyped(json, false);
}
export function UserProfileToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'displayName': value['displayName'],
        'email': value['email'],
        'name': value['name'],
        'photoURL': value['photoURL'],
    };
}
